import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ChevronRight: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 7 11'>
      <path
        d='M7 5.51085L1.98556 0.647005C1.82461 0.48928 1.60738 0.398242 1.37921 0.392883C1.26324 0.392881 1.14842 0.415243 1.04136 0.458677C0.934291 0.502111 0.837098 0.565758 0.755377 0.645959C0.673657 0.72616 0.609027 0.821328 0.565201 0.92598C0.521376 1.03063 0.499221 1.14271 0.500021 1.25574C0.503274 1.47743 0.594553 1.68926 0.754683 1.84673L4.52007 5.51676L0.754683 9.18091C0.595609 9.33907 0.504516 9.55047 0.500021 9.7719C0.503274 9.99359 0.594553 10.2054 0.754683 10.3629C0.922819 10.5197 1.14653 10.6072 1.37921 10.6072C1.6119 10.6072 1.83561 10.5197 2.00374 10.3629C2.17188 10.2061 7 5.51085 7 5.51085Z'
        fill={props.fill}
      />
    </SvgIcon>
  );
};
